module.exports = __webpack_public_path__ + "img/Chest-Nut-Tree-Marathon.ab523419.jpg";